const VERSION = "7.2.3";
export {
  VERSION
};
